import { History, CheckCircle, Clock, XCircle } from "lucide-react";
import { Card, CardContent, CardHeader } from "../ui/card";
import type { Payment } from "../../types/membership";
import { dictionary } from "../../utils/dictionary";
import { useAuth } from "../../context/AuthContext";

interface PaymentHistoryProps {
  payments: Payment[];
}

export function PaymentHistorySection({ payments }: PaymentHistoryProps) {
  const { language } = useAuth();
  
  return (
    <Card>
      <CardHeader>
        <div className="flex items-center space-x-3">
          <div className="w-10 h-10 bg-gray-200 rounded-lg flex items-center justify-center">
            <History className="w-5 h-5 text-gray-600" />
          </div>
          <h3 className="text-xl font-bold text-gray-900">
            {dictionary["payment-history"][language]}
          </h3>
        </div>
      </CardHeader>
      <CardContent className="p-0">
        <div className="divide-y divide-gray-200">
          {payments.map((payment) => (
            <div
              key={payment.id}
              className="flex items-center justify-between p-4 border border-gray-200 rounded-xl hover:bg-gray-50 transition-colors duration-200 w-[90%] m-auto mb-4"
            >
              <div className="flex items-center space-x-4">
                <div className="w-10 h-10 bg-gray-200 rounded-lg flex items-center justify-center">
                  <CheckCircle className="w-5 h-5 text-gray-600" />
                </div>
                <div>
                  <p className="font-semibold text-gray-900">
                    ${payment.total_value}
                  </p>
                  <p className="text-sm text-gray-500">
                    {payment.provider_id} - {payment.origin}
                  </p>
                </div>
              </div>
              <div className="text-right">
                <p className="font-medium text-gray-900">
                  {new Date(payment.created_at).toLocaleDateString()}
                </p>
                <span className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-gray-100 text-gray-700`}>
                  {dictionary["succeeded"][language] || payment.state}
                </span>
              </div>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
}
